// Copyright 2026. WebPros International GmbH. All rights reserved.

export const SET_EXTERNAL_INTEGRATION_LIST = 'externalIntegration/SET_EXTERNAL_INTEGRATION_LIST';
export const ADD_EXTERNAL_INTEGRATION_ITEM = 'externalIntegration/ADD_EXTERNAL_INTEGRATION_ITEM';
export const SET_EXTERNAL_INTEGRATION_ITEM_IS_DELETING = 'externalIntegration/SET_EXTERNAL_INTEGRATION_ITEM_IS_DELETING';
export const REMOVE_EXTERNAL_INTEGRATION_ITEM = 'externalIntegration/REMOVE_EXTERNAL_INTEGRATION_ITEM';
export const SET_EXTERNAL_INTEGRATION_ITEM = 'externalIntegration/SET_EXTERNAL_INTEGRATION_ITEM';
export const UNSET_EXTERNAL_INTEGRATION_ITEM = 'externalIntegration/UNSET_EXTERNAL_INTEGRATION_ITEM';
export const UPDATE_EXTERNAL_INTEGRATION_ITEM = 'externalIntegration/UPDATE_EXTERNAL_INTEGRATION_ITEM';
